export const formDefault = {
  busca_produto: { label: undefined, value: undefined },
  cod_tipo_ajuste_pai: { label: undefined, value: undefined },
  cod_tipo_ajuste_filho: { label: undefined, value: undefined },
  qtd_producao: '',
};
